module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "dev-page"
  }, [_c('div', {
    staticClass: "dev-page-header"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dph-buttons pull-right"
  }, [(!_vm.authenticated) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Log In")])]) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('li', [_c('span', {
    staticStyle: {
      "line-height": "55px",
      "margin-right": "30px",
      "display": "inline-block",
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.profile.authProfile && _vm.profile.authProfile.email))])]) : _vm._e(), _vm._v(" "), (_vm.authenticated && _vm.hasUserOrganizationList()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "20px",
      "display": "inline-block",
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.getFirstOrganization()))])])]) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.profile.authProfile || {}).picture,
      "height": "25",
      "width": "25"
    }
  }), _c('span', {
    staticStyle: {
      "margin-left": "5px",
      "display": "inline-block",
      "vertical-align": "middle"
    }
  }, [_vm._v("Log Out")])])]) : _vm._e()]), _vm._v(" "), _c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.httpRunning),
      expression: "httpRunning"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dev-page-container"
  }, [_c('div', {
    staticClass: "dev-page-sidebar"
  }, [_c('ul', {
    staticClass: "dev-page-navigation"
  }, [_c('li', {
    staticClass: "title"
  }, [_vm._v("NAVIGATION")]), _vm._v(" "), _c('li', [(!_vm.authenticated) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-log-in"
  }), _vm._v("Log In")]) : _vm._e()]), _vm._v(" "), (!_vm.authenticated) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/PublicE106",
      "tag": "a"
    }
  }, [_vm._v("Submit E106")])], 1) : _vm._e(), _vm._v(" "), (_vm.authenticated && _vm.hasRoleList && !_vm.isPublicUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/HelpInfo",
      "tag": "a"
    }
  }, [_vm._v("Getting Started")])], 1) : _vm._e(), _vm._v(" "), (_vm.authenticated && _vm.hasRoleList && !_vm.isPublicUser) ? _c('li', {
    staticClass: "has_child"
  }, [_c('router-link', {
    attrs: {
      "to": "/Dashboard",
      "tag": "a"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v("Dashboard")]), _vm._v(" "), (_vm.isCLGConsultantE106User) ? _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/Projects",
      "tag": "a"
    }
  }, [_vm._v("Projects")])], 1)]) : _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/Projects",
      "tag": "a"
    }
  }, [_vm._v("Projects")])], 1), _vm._v(" "), (!_vm.isViewOnlyUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/FieldWorkRequests",
      "tag": "a"
    }
  }, [_vm._v("Field Work Requests")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isViewOnlyUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/FileSearches",
      "tag": "a"
    }
  }, [_vm._v("File Search")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Investigations",
      "tag": "a"
    }
  }, [_vm._v("Investigations")])], 1), _vm._v(" "), (!_vm.isConsultant && !_vm.isViewOnlyUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/Undertakings",
      "tag": "a"
    }
  }, [_vm._v("Undertakings")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isConsultant && !_vm.isViewOnlyUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/MoasPas",
      "tag": "a"
    }
  }, [_vm._v("MOAs / PAs")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isViewOnlyUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/Map",
      "tag": "a"
    }
  }, [_vm._v("Map")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/MapPublic",
      "tag": "a"
    }
  }, [_vm._v("Risk Layer Map")])], 1), _vm._v(" "), (!_vm.isViewOnlyUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/CulturalResources",
      "tag": "a"
    }
  }, [_vm._v("Production Record Search")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', {
    staticClass: "has-child",
    on: {
      "click": function($event) {
        _vm.toggleNavItem('isAdminHidden')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Administration")]), _vm._v(" "), _c('ul', [_c('li', {
    class: {
      'child-nav': _vm.isAdminHidden
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/Organization",
      "tag": "a"
    }
  }, [_vm._v("Organization")])], 1), _vm._v(" "), _c('li', {
    class: {
      'child-nav': _vm.isAdminHidden
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/UserAdministration",
      "tag": "a"
    }
  }, [_vm._v("User Administration")])], 1), _vm._v(" "), _c('li', {
    class: {
      'child-nav': _vm.isAdminHidden
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/LetterTemplates",
      "tag": "a"
    }
  }, [_vm._v("Letter Templates")])], 1), _vm._v(" "), _c('li', {
    class: {
      'child-nav': _vm.isAdminHidden
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/ProjectsDelete",
      "tag": "a"
    }
  }, [_vm._v("Delete Projects")])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isViewOnlyUser) ? _c('li', {
    staticClass: "has-child",
    on: {
      "click": function($event) {
        _vm.toggleNavItem('isMiscHidden')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('ul', [(!_vm.isViewOnlyUser) ? _c('li', {
    class: {
      'child-nav': _vm.isMiscHidden
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/SiteNumberRequests",
      "tag": "a"
    }
  }, [_vm._v("Off inventory site number request")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', {
    class: {
      'child-nav': _vm.isMiscHidden
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/BlmDataExport",
      "tag": "a"
    }
  }, [_vm._v("BLM Data Export")])], 1) : _vm._e()])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.authenticated && !_vm.isPublicUser) ? _c('li', {
    staticClass: "has_child"
  }, [_c('ul', [(!_vm.isViewOnlyUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/Reports",
      "tag": "a"
    }
  }, [_vm._v("Reports")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.authenticated && _vm.isPublicUser) ? _c('li', {
    staticClass: "has_child"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/MapPublic",
      "tag": "a"
    }
  }, [_vm._v("Map")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.authenticated && (!_vm.hasRoleList || _vm.isShpo)) ? _c('li', {
    staticClass: "has_child"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/UserInfo",
      "tag": "a"
    }
  }, [_vm._v("User Info")])], 1)])]) : _vm._e()])]), _vm._v(" "), (_vm.errorList.length > 0) ? _c('div', {
    staticClass: "errorMessages alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.errorMessageClear()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "has-error",
    staticStyle: {
      "margin-bottom": "10px",
      "border-bottom": "1px solid"
    }
  }, [_vm._v("Errors have occurred:")]), _vm._v(" "), _c('div', {
    staticClass: "has-error",
    staticStyle: {
      "margin-left": "10px"
    }
  }, _vm._l((_vm.errorList), function(error) {
    return _c('div', {
      key: error.id,
      staticStyle: {
        "margin-bottom": "10px",
        "border-bottom": "1px solid"
      }
    }, [_vm._v("\n                  " + _vm._s(error.time)), _c('br'), _vm._v("\n                  " + _vm._s(error.status) + _vm._s(error.message)), _c('br'), _vm._v("\n                  " + _vm._s(error.url)), _c('br')])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dev-page-content",
    staticStyle: {
      "border": "1px 1px 1px 1px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', [_c('router-view', {
    attrs: {
      "auth": _vm.auth,
      "authenticated": _vm.authenticated
    }
  })], 1)]), _vm._v(" "), (!_vm.authenticated) ? _c('div', [_vm._v("\n                  " + _vm._s(_vm.loginMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isDebug) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "30px",
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "display": "inline-block",
      "vertical-align": "top"
    }
  }, [_vm._v("\n                          authenticated: " + _vm._s(_vm.authenticated)), _c('br'), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                          name: " + _vm._s((_vm.profile.authProfile || {}).name)), _c('br'), _vm._v("\n                          email: " + _vm._s((_vm.profile.authProfile || {}).email)), _c('br'), _vm._v("\n                          user_id: " + _vm._s((_vm.profile.authProfile || {}).user_id)), _c('br'), _vm._v("\n                          roleList: " + _vm._s(_vm.shpoUserDto && _vm.shpoUserDto.roleList)), _c('br'), _vm._v("\n                          userOrganizationList: " + _vm._s(_vm.shpoUserDto && _vm.shpoUserDto.userOrganizationList)), _c('br'), _vm._v(" "), _vm._v("\n                          is idle: " + _vm._s(_vm.isAppIdle) + "\n                          ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('time-out-modal', {
    attrs: {
      "auth": _vm.auth,
      "authenticated": _vm.authenticated
    }
  })], 1), _vm._v(" "), _vm._m(1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dph-logo"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("WY - SHPO")]), _vm._v(" "), _c('a', {
    staticClass: "dev-page-sidebar-collapse"
  }, [_c('div', {
    staticClass: "dev-page-sidebar-collapse-icon"
  }, [_c('span', {
    staticClass: "line-one"
  }), _vm._v(" "), _c('span', {
    staticClass: "line-two"
  }), _vm._v(" "), _c('span', {
    staticClass: "line-three"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dev-page-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-evenly",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px",
      "font-size": "14px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "http://ag.wyo.gov/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    }
  }, [_c('div', [_vm._v("Wyoming State Historic Preservation Office")]), _vm._v(" "), _c('div', [_vm._v("2301 Central Ave.\n                  Barrett Building - 3rd Floor\n                  Cheyenne, WY 82002")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "mailto:spcr.wycro@wyo.gov"
    }
  }, [_vm._v("spcr.wycro@wyo.gov")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-067622af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 891
// module chunks = 1